<template>
    <div class='swiperBox'>
        <swiper ref="mySwiper" :options="swiperOptions" class="mySwiper">
            <swiper-slide class='swiperSlider' v-for='(item,index) in swiperData' :key='index'>
                <div class="item-box" @click='toPath(item.url)'>
                    <div class="item-img-box">
                        <img :src="item.imgurl" alt="图" class="imgitme">
                    </div>
                    <h4 class="item-caption" v-if='item.caption'>{{item.caption}}</h4>
                    <div class="item-center-box" v-if='item.title' v-html='item.title'></div>
                </div>
            </swiper-slide>
            <!-- <swiper-slide class='swiperSlider'>
                <div class="item-box" @click='toPath(baseUrl)'>
                    <div class="item-img-box last-item">
                        <div class="button"></div>
                        <ul class="text-title">
                            <li class="item-text-title">查看更多</li>
                            <li class="item-text-title">查看更多</li>
                        </ul>
                    </div>
                </div>
            </swiper-slide> -->
            <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
        <el-dialog title="立即咨询我们的数字营销专家" :visible.sync="centerDialogVisible" :width="fromTableWidth" center
            append-to-body class="myFrom" destroy-on-close>
            <From></From>
        </el-dialog>
    </div>
</template>
<script>
    import From from '@/components/base/fromtable'//引入表单
    export default {
        name: 'Swiperbox',
        props: {
            swiperData: Array,
            swiperOptions: Object,
            scrollbar: String,
            baseUrl: String
        },
        components: {
            From
        },
        data() {
            return {
                centerDialogVisible: false,
                fromTableWidth: undefined
                // swiperOptions: {
                //     // autoplay: { //匀速滚动
                //     //     delay: 3000, //间隔时间0秒
                //     //     stopOnLastSlide: false,
                //     //     disableOnInteraction: false, //触摸后仍然执行
                //     // },
                //     scrollbar: {
                //         el: '.swiper-scrollbar',
                //         hide: true
                //     },
                //     slidesPerView: 1.5,
                //     spaceBetween: 48,
                //     grabCursor: true
                //     // Some Swiper option/callback...
                // },
                // swiperData: [
                //     {
                //         imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                //         caption: '数字化营销服务',
                //         title: '<p>我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p>我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>'
                //     },
                //     {
                //         imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                //         caption: '数字化营销服务',
                //         title: '<p>我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p>我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>'
                //     },
                //     {
                //         imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                //         caption: '数字化营销服务',
                //         title: '<p>我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p>我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>'
                //     },
                //     {
                //         imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                //         caption: '数字化营销服务',
                //         title: '<p>我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p>我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>'
                //     },
                //     {
                //         imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                //         caption: '数字化营销服务',
                //         title: '<p>我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p>我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>'
                //     }
                // ]
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },
        mounted() {
            // console.log('Current Swiper instance object', this.swiper)
            this.getWidth()
            this.swiper.scrollbar.$dragEl.css('background', this.scrollbar);
            // this.swiper.slideTo(3, 1000, false)
        },
        methods: {
            toPath(url) {
                if (url == null) {
                    this.centerDialogVisible = true
                    return
                } else {
                    window.location.href = url
                }
            },
            getWidth() {//获取设备的宽度
                const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                windowWidth < 995 ? this.fromTableWidth = '100%' : this.fromTableWidth = '60%'

            }
        }
    }
</script>
<style scoped>
    .swiperBox,
    .mySwiper {
        width: 100%;
        height: 100%;
    }

    .swiperSlider {
        background: #ffffff;
        overflow: hidden;
        height: 100%;
    }

    .item-box {
        width: 100%;
        height: 100%;
    }

    .item-img-box {
        /* height: 480px;
        background: transparent no-repeat center center;
        background-size: 100%; */
        /* border: 1px solid #1f1f1f; */
    }

    .imgitme {
        width: 100%;
    }

    .item-caption {
        font-size: 24px;
        font-weight: 500;
        line-height: 33px;
        color: rgba(28, 28, 28, 1);
        margin: 28px 0 18px 0;
    }

    .item-center-box>>>p {
        font-size: 16px;
        font-weight: 300;
        line-height: 28px;
        color: #000000;
        padding-bottom: 5%;
    }

    .last-item {
        background-color: #ffffff;
        border: 1px solid #000000;
        transition: all 0.5s;
        position: relative;
    }

    .last-item::after {
        content: '';
        width: 100%;
        height: 0%;
        background-color: #2488F8;
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        transition: all 0.5s;

    }

    .last-item:hover::after {
        height: 100%;
    }

    .button {
        position: absolute;
        border: 2px solid #ffffff;
        width: 40px;
        height: 40px;
        z-index: 3;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -150%);
        cursor: pointer;
        transition: all 0.5s;
    }

    .button::after {
        content: '';
        height: 2px;
        width: 2px;
        background-color: #000000;
        position: absolute;
        top: 50%;
        left: 50%;
        box-shadow: -6px 0 #000000;
        transform: translate(-50%, -50%);
        transition: all 0.5s;
    }

    .button::before {
        content: '';
        height: 2px;
        width: 2px;
        background-color: #000000;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(250%, -50%);
        transition: all 0.5s;
    }

    .text-title {
        height: 24px;
        overflow: hidden;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
    }

    .text-title>li {
        font-size: 16px;
        font-weight: 400;
        line-height: 137.5%;
        transition: all 0.5s;
    }

    .text-title>li:last-child {
        color: #ffffff;
    }

    .last-item:hover .text-title>li {
        transform: translateY(-100%);
    }

    .last-item:hover .button {
        width: 50px;
        height: 50px;
    }

    .last-item:hover .button::after {
        background-color: #ffffff;
        box-shadow: -6px 0 #ffffff;
    }

    .last-item:hover .button::after {
        background-color: #ffffff;
        box-shadow: -6px 0 #ffffff;
    }

    .last-item:hover .button::before {
        background-color: #ffffff;
    }

    .QR {
        display: block;
        height: 400Px;
        width: 400Px;
        margin: 0 auto;
    }


    /* ================================================================表单样式 ========================================================*/
    .myFrom .fromtable>>>.Myfrom {
        padding: 0 5%;
        display: grid;
        width: 100%;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 5%;
        grid-template-areas: 'Name Company'
            'Email Tel'
            'Captiond Captiond'
            'DemandContent DemandContent'
            'Submit Submit';
    }

    .fromtable>>>.subMit {
        justify-self: center;
        background-color: #000;
        width: 168px;
        height: 50px;
        border-radius: 30px;
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        color: #ffffff;
    }

    .fromtable>>>.el-input__inner {
        border: none;
        border-radius: 0%;
        height: 60px;
        border-bottom: 1px solid #333;
    }

    .fromtable>>>.el-textarea__inner {
        border: 1px solid #333;
    }

    @media (max-width: 995px) {
        .item-box {
            padding-top: 8%;
        }
    }

    /* @media(max-width: 1023px) {
        .item-img-box {
            width: 100%;
            height: 1000px;
            overflow: hidden;
        }

        .swiper-scrollbar {
            display: none;
        }

        .item-caption {
            padding-left: 5%;
            font-size: 70px;
            line-height: 137.5%;
        }

        .item-center-box>>>p {
            padding-left: 5%;
            font-size: 50px;
            line-height: 175%;
        }

        .text-title {
            height: 50px;
        }

        .text-title>li {
            font-size: 40px;
        }
        .button{
            display: none;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/base/swiper.vue